import React from 'react';
import { CloseableModal } from '../../../../../../../components/CloseableModal';
import { useForm } from 'react-hook-form';
import { loadLocationOptions } from '..';
import { SelectOption } from '../../../../../../../components/Select';
import { LocationEntity } from '../../../../../../../services/GeoLocationService';
import { ModalBody } from './ModalBody';
import { AlertType } from '../../../../../../../components/Alert';

interface PropTypes {
  setIsModalOpen: (isOpen: boolean) => void;
  setLocationOptions: (selectedOption: SelectOption[]) => void;
  setSelectedLocation: (selectedOption: SelectOption) => void;
  setIsLoading: (isLoading: boolean) => void;
  isModalOpen: boolean;
  setAlertType: (alertType: AlertType) => void;
  setAlertMessage: (message: JSX.Element) => void;
  setIsAlertVisible: (isVisible: boolean) => void;
}

export interface LocationValue {
  locationName: string;
  location: LocationEntity;
}

export function CreateLocationModal(props: PropTypes) {
  const { register, handleSubmit, formState, reset, getValues, control } =
    useForm<LocationValue>({
      mode: 'onChange',
      defaultValues: {
        location: null,
      },
    });

  const handleClose = () => {
    props.setIsModalOpen(false);
    reset();
    props.setIsAlertVisible(true);

    loadLocationOptions()
      .then(props.setLocationOptions)
      .finally(() => props.setIsLoading(false));
  };

  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={handleClose}
      isOpen={props.isModalOpen}
      size='md'
      closeDisabled={false}
      keyboard={true}
      backdrop={true}
      headerTitle={'Create Location'}
      bodyChildren={
        <ModalBody
          handleSubmit={handleSubmit}
          register={register}
          isValid={formState.isValid}
          handleClose={handleClose}
          getValues={getValues}
          control={control}
          setSelectedLocation={props.setSelectedLocation}
          setAlertType={props.setAlertType}
          setAlertMessage={props.setAlertMessage}
        />
      }
    />
  );
}
